/* Ask me anything, homepage only.
   Talks to the Supabase `ask` function, which answers strictly from the
   indexed pages and refuses anything else. The caps live server side: ten
   questions a visit, thirty a day per person, and a global daily ceiling.
   Nothing personal is sent. The session id exists only so the server can
   apply the per-visit cap. */
(function () {
  var ENDPOINT = 'https://ivjdusmzasomnhilktjh.supabase.co/functions/v1/ask';
  var MAX = 400;

  function sessionId() {
    try {
      var k = 'rk_ask_session';
      var v = sessionStorage.getItem(k);
      if (!v) {
        v = String(Date.now()) + '-' + Math.random().toString(36).slice(2, 10);
        sessionStorage.setItem(k, v);
      }
      return v;
    } catch (e) {
      return 'nostore-' + Math.random().toString(36).slice(2, 10);
    }
  }

  var ENTITIES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return ENTITIES[c]; });
  }

  /* The model is told to end with "More: <url>". Render that as a link and
     leave everything else as plain escaped paragraphs. */
  function render(answer) {
    return String(answer).split(/\n{2,}/).map(function (para) {
      var t = para.trim();
      if (!t) return '';
      var m = t.match(/^More:\s*(https?:\/\/\S+)$/i);
      if (m) return '<p><a href="' + esc(m[1]) + '">Read the full page</a></p>';
      return '<p>' + esc(t).replace(/\n/g, '<br>') + '</p>';
    }).join('');
  }

  function card(inner) {
    return '<div class="rk-ask__card">' + inner + '</div>';
  }

  function mount() {
    if (document.querySelector('.rk-ask')) return;

    var sec = document.createElement('section');
    sec.className = 'rk-ask';
    sec.setAttribute('aria-labelledby', 'rk-ask-title');
    sec.innerHTML = [
      '<div class="rk-ask__wrap">',
      '<span class="rk-ask__eyebrow">Ask me anything</span>',
      '<h2 id="rk-ask-title">Questions about Rockkt, answered from this site</h2>',
      '<p class="rk-ask__lede">Pricing, how the address finding works, what is allowed under UK rules. If the answer is not on the site it will say so rather than guess.</p>',
      '<form class="rk-ask__form">',
      '<label for="rk-ask-q" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Your question</label>',
      '<input class="rk-ask__input" id="rk-ask-q" type="text" maxlength="' + MAX + '" autocomplete="off" placeholder="What does a credit actually buy me?">',
      '<button class="rk-ask__btn" type="submit">Ask</button>',
      '</form>',
      '<p class="rk-ask__hint">Answers come from the pages on this site. We do not ask for your details.</p>',
      '<div class="rk-ask__out" aria-live="polite"></div>',
      '</div>'
    ].join('');

    var footer = document.querySelector('footer');
    if (footer && footer.parentNode) footer.parentNode.insertBefore(sec, footer);
    else document.body.appendChild(sec);

    var form = sec.querySelector('.rk-ask__form');
    var input = sec.querySelector('.rk-ask__input');
    var btn = sec.querySelector('.rk-ask__btn');
    var out = sec.querySelector('.rk-ask__out');
    var busy = false;

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (busy) return;
      var q = input.value.trim();
      if (!q) return;

      busy = true;
      btn.disabled = true;
      btn.textContent = 'Asking';
      out.innerHTML = card('<p class="rk-ask__thinking">Looking through the site...</p>');

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ question: q, session: sessionId(), page: location.href })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.answer) out.innerHTML = card(render(data.answer));
          else out.innerHTML = card('<p>Something went wrong at our end. Email hello@rockkt.com and a person will answer.</p>');
        })
        .catch(function () {
          out.innerHTML = card('<p>I could not reach the answer service. Email hello@rockkt.com and a person will answer.</p>');
        })
        .then(function () {
          busy = false;
          btn.disabled = false;
          btn.textContent = 'Ask';
        });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
